import type { GeoPt } from '../types'

/** A projected point: x east, y north, both in EPSG:3857 metres. */
export type Pt2 = [number, number]

/** The sphere EPSG:3857 is defined on. */
export const EARTH_RADIUS_M = 6378137

const DEG = Math.PI / 180

/**
 * Spherical Web Mercator, in metres, the projection the app's `ground_combine`
 * does all of its wash geometry in. `geo.ts` keeps only a normalised [0, 1]
 * Mercator y for label sizing; the wash needs both axes in a unit the margin
 * constants (1 km, 10 km) are stated in, so it has its own pair.
 */
export function toMercator(p: GeoPt): Pt2 {
  const x = EARTH_RADIUS_M * p.lon * DEG
  const y = EARTH_RADIUS_M * Math.asinh(Math.tan(p.lat * DEG))
  return [x, y]
}

export function fromMercator([x, y]: Pt2): GeoPt {
  const lon = x / EARTH_RADIUS_M / DEG
  const lat = (2 * Math.atan(Math.exp(y / EARTH_RADIUS_M)) - Math.PI / 2) / DEG
  return { lat, lon }
}
